export default __webpack_public_path__ + "static/media/logo-vertical.958030eb.png";